import { INTERVENE_USER_TABS } from '../constants/interveneApi';

const FIFTEEN_MIN_MS = 15 * 60 * 1000;
const TWENTY_FOUR_H_MS = 24 * 60 * 60 * 1000;

function parseDate(value) {
  if (!value) return null;
  if (typeof value === 'object') {
    if (value.$date) return parseDate(value.$date);
    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value;
    }
  }
  const raw = String(value).trim();
  if (!raw) return null;
  const date = new Date(raw.includes('T') ? raw : raw.replace(' ', 'T'));
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Mirrors ActiveChatUser._build_tab_query bucket rules (frontend-side).
 */
export function getUserTabBucket(user, now = new Date(), currentUserId = null) {
  if (!user || typeof user !== 'object') return null;

  const nowMs = now.getTime();
  const lastActive = parseDate(user.last_active_date || user.updated_at);
  const updatedAt = parseDate(user.updated_at);
  const intervenedAt = parseDate(user.intervened_at);
  const isIntervene = user.intervene === true;

  if (isIntervene) {
    const refTime = updatedAt || intervenedAt;
    if (refTime) {
      const refAgeMs = nowMs - refTime.getTime();
      if (refAgeMs >= 0 && refAgeMs <= TWENTY_FOUR_H_MS) {
        return INTERVENE_USER_TABS.INTERVENE;
      }
    }
    if (user.session_start === true || user.session_start) {
      return INTERVENE_USER_TABS.INTERVENE;
    }
    return INTERVENE_USER_TABS.INTERVENE;
  }

  if (!lastActive) {
    return isIntervene ? INTERVENE_USER_TABS.INTERVENE : null;
  }

  const lastActiveMs = lastActive.getTime();

  if (lastActiveMs < nowMs - TWENTY_FOUR_H_MS) {
    return INTERVENE_USER_TABS.HISTORY;
  }

  const ageMs = nowMs - lastActiveMs;
  if (ageMs <= FIFTEEN_MIN_MS) {
    return INTERVENE_USER_TABS.RECENT_15M;
  }
  if (ageMs <= TWENTY_FOUR_H_MS) {
    return INTERVENE_USER_TABS.ACTIVE_24H;
  }

  return null;
}

export function userBelongsToTab(user, tabValue, now = new Date(), currentUserId = null) {
  if (!tabValue) return false;
  return getUserTabBucket(user, now, currentUserId) === tabValue;
}

/**
 * Prefer backend-computed user_status from list_item when available.
 */
export function userMatchesActiveTab(user, tabValue, now = new Date(), currentUserId = null) {
  if (!tabValue) return false;
  if (tabValue === INTERVENE_USER_TABS.INTERVENE) {
    if (user?.intervene === false || user?.is_intervene === false) {
      return false;
    }
    return Boolean(
      user?.intervene === true ||
      user?.is_intervene === true ||
      (user?.session_start && user?.session_start !== false) ||
      `${user?.user_status}` === INTERVENE_USER_TABS.INTERVENE
    );
  }
  if (user?.user_status) {
    return `${user.user_status}` === `${tabValue}`;
  }
  return userBelongsToTab(user, tabValue, now, currentUserId);
}
